import { render, staticRenderFns } from "./createAssetModel.vue?vue&type=template&id=bfa0bbca&scoped=true"
import script from "./createAssetModel.vue?vue&type=script&lang=js"
export * from "./createAssetModel.vue?vue&type=script&lang=js"
import style0 from "./createAssetModel.vue?vue&type=style&index=0&id=bfa0bbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa0bbca",
  null
  
)

export default component.exports